import React from 'react';
import { motion } from 'framer-motion';
export function Slide4Funnel() {
  const stages = [{
    name: 'Pre-Congress',
    desc: 'Agenda setting',
    label: 'Reach',
    width: '100%',
    color: 'bg-gray-100'
  }, {
    name: 'Vicinity',
    desc: 'Attention capture',
    label: 'Interest',
    width: '85%',
    color: 'bg-gray-200'
  }, {
    name: 'Venue',
    desc: 'Message reinforcement',
    label: 'Intent',
    width: '70%',
    color: 'bg-gray-300'
  }, {
    name: 'Aisle',
    desc: 'Barrier breaker',
    label: 'Interaction',
    width: '55%',
    color: 'bg-[#E60012]/20'
  }, {
    name: 'Booth',
    desc: 'Qualified engagement',
    label: 'Qualification',
    width: '40%',
    color: 'bg-[#E60012]/60'
  }, {
    name: 'Post-Congress',
    desc: 'Segmented follow-up',
    label: 'Follow-up',
    width: '25%',
    color: 'bg-[#E60012]'
  }];
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-12 md:px-24 md:pt-20 md:pb-28 relative overflow-hidden" data-id="element-151">
      <header className="mb-10" data-id="element-152">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-[#1A202C] mb-4" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-153">
          The Congress Conversion Funnel
        </motion.h2>
        <motion.p className="text-xl text-[#4A5568] font-light max-w-3xl" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-154">
          From awareness to qualified engagement, each stage moves the HCP one
          step closer to a relevant next action.
        </motion.p>
      </header>

      <main className="flex-1 flex flex-col justify-center max-w-5xl mx-auto w-full" data-id="element-155">
        <div className="space-y-4 w-full" data-id="element-156">
          {stages.map((stage, index) => <motion.div key={stage.name} className="flex items-center gap-6" initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2 + index * 0.1
        }} data-id="element-157">
              <div className="w-48 text-right shrink-0" data-id="element-158">
                <h3 className="font-bold text-[#1A202C] text-lg" data-id="element-159">
                  {stage.name}
                </h3>
                <p className="text-sm text-[#4A5568]" data-id="element-160">{stage.desc}</p>
              </div>

              <div className="flex-1 h-16 bg-white rounded-r-xl shadow-sm border border-gray-100 flex items-center relative overflow-hidden" data-id="element-161">
                <motion.div className={`absolute top-0 left-0 h-full ${stage.color}`} initial={{
              width: 0
            }} animate={{
              width: stage.width
            }} transition={{
              duration: 1,
              delay: 0.5 + index * 0.1,
              ease: 'easeOut'
            }} data-id="element-162" />
                <div className="relative z-10 px-6 font-semibold text-[#1A202C] tracking-wide uppercase text-sm" data-id="element-163">
                  {stage.label}
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div className="mt-8 bg-white p-6 rounded-xl shadow-sm border border-gray-100 text-center" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 1.2
      }} data-id="element-164">
          <p className="text-[#2D3748] font-medium" data-id="element-165">
            The goal is not to reach everyone equally. The goal is to move the
            right HCPs to the right next step, with data captured at every
            stage.
          </p>
        </motion.div>
      </main>
    </div>;
}